import React from "react"
import { useMediaQuery } from 'react-responsive'
import { Link } from "gatsby"
import PropTypes from 'prop-types'
import Layout from "../components/layout"
import Logo from "../components/logo"
import SEO from "../components/seo"
import FeatureBoxElement from "../components/FeatureBox"
import StoryPreviewSquare from '../components/StoryPreviewSquare'
import TypedJsElement from '../components/TypedJs'
import { graphql } from 'gatsby'
import styled from 'styled-components'

const IndexPageTemplate = ({heroTitle, html, recentStories}) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1025px)' });
  const TypedLimit = useMediaQuery({ query: '(max-width: 1440px)' });
  const storiesLink = recentStories[0].node.fields.slug;

  const Index = styled.div`
    @media (max-width: 1024px) {
      #logo {
        width: 310px;
      }

      #index-right-column {
        display: none;
      }
    }

    @media (min-width: 1025px) {
      #logo {
        width: 380px;
      }
    }
  `

  return (
    <Layout>
      <SEO title="Home" />
      <Index>
        <div className='columns'>
          <div className="column">
            <Logo id="logo" width='320px' margin='40' />
            <FeatureBoxElement heroTitle={heroTitle} html={html} />
            <h1 className='white' style={{marginLeft: '15px', marginTop: '3rem'}}>Recent stories</h1>
            <div className="columns">
              {recentStories.map((story) => {
                return(
                  <div key={story.node.fields.slug} className="column">
                    <StoryPreviewSquare storyData={story} />
                  </div>
                )
              })}
            </div>
            <div style={{justifyContent: 'flex-end', display: 'flex'}}>
              <h5><Link className='preview-link' to={isTabletOrMobile ? 'stories_index' : storiesLink}>See all...</Link></h5>
            </div>
          </div>
          <div id="index-right-column" className="column content-center-right">
              <div className="typedjsContainer">
                <TypedJsElement strings={[
                  `Our forest is in <strong>danger</strong>.\n
                  It is <strong>our</strong> main source of sustinance.\n
                  Without it, our lives are at <strong>risk</strong>.\n
                  <strong>Together</strong>, we can protect it.` ]} 
                  fontSize={TypedLimit ? '1.7em' : '2.2em'} />
                </div>
          </div>
        </div>
      </Index>
    </Layout>
  )
}

IndexPageTemplate.propTypes = {
  heroTitle: PropTypes.string,
  html: PropTypes.string,
}

const IndexPage = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark

  return (
      <IndexPageTemplate
        heroTitle={frontmatter.heroTitle}
        html={html}
        recentStories={data.allMarkdownRemark.edges}
      />
  )
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "indexTemplate" } }) {
      frontmatter {
        heroTitle
      }
      html
    }
    allMarkdownRemark(limit: 2, sort: {fields: frontmatter___date, order: DESC}, filter: {frontmatter: {templateKey: {eq: "storiesTemplate"}}}) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            image {
              childImageSharp {
                fixed(width: 400, height: 160, quality: 30, cropFocus: CENTER) {
                  ...GatsbyImageSharpFixed
                }
              }
            } 
            title
          }
          excerpt(pruneLength: 165)
        }
      }
    }
  }
`
